module.exports = __webpack_public_path__ + "static/img/gggggg_05.b5ce1c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_05.png
// module id = Es3f
// module chunks = 1